import { useContext } from 'react';
import { IPrimarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { StickyLayoutPrimarySlots } from 'utilities/sticky/stickySlots.js';
import { MapSlotContext } from './map-slot-context.js';

// Moves zoom and map in proportion based on if the mapSlot area has content
const MapLargeLeftSlotClass = ({ filteredPrimaryConfig }: { filteredPrimaryConfig: IPrimarySlotPropsMap }) => {
  const { mapSlot } = useContext(MapSlotContext);

  const hasLeftSlotContent =
    mapSlot?.length || filteredPrimaryConfig.leftMajor.modules.length || filteredPrimaryConfig.leftMinor.modules.length;

  if (hasLeftSlotContent) {
    return 'u-lg-width1of3 u-xl-width3of12';
  }
  return 'u-hidden';
};

/**
 * Renders map layout with slots over the top of map canvas
 * MapSlot callback is passed to map which is used to update map slot on icon select
 */

export const MapLargeLeftSlotWrapper = ({
  /** searchBarOffset increases when searchbar is displaying */
  filteredPrimaryConfig,
  children,
}: {
  filteredPrimaryConfig: IPrimarySlotPropsMap;
  children: JSX.Element;
}) => {
  const contentClass = MapLargeLeftSlotClass({ filteredPrimaryConfig });

  return (
    <StickyLayoutPrimarySlots isSticky={true} offset={1} classes={`Grid-cell Layout-sidebar ${contentClass}`}>
      {children}
    </StickyLayoutPrimarySlots>
  );
};
